<template>
  <header class="header-main_area pr-28" style="background-color: #fff">
    <!-- 顶部信息 -->
    <div class="header-middle_area">
      <div class="container">
        <el-row :gutter="30" type="flex" align="middle">
          <el-col :span="5">
            <div class="header-logo">
              <router-link to="/home">
                <!-- <div class="shouyeImg flex-row">
                  <img
                    src="../../assets/images/deflault_load.png"
                    style="width: 48%; height: 90%;"
                    class=""
                  />

                  <div
                    class="flex-row text_font fs-25 flex-col mt-7 ml-10"
                    style="width: 100px"
                  >
                    <div class="">{{ $t("广园汇") }}</div>
                    <div class=" " style="white-space: nowrap">
                      {{ $t("汽配港") }}
                    </div>
                  </div>
                </div> -->
                <div style="width: 100%;margin-top: -20px;">
                  <img src="../../assets/images/deflault_logo.png" class="" />
                </div>
              </router-link>
            </div>
          </el-col>

          <el-col :lg="12" :md="12" class="d-none d-lg-block">
            <!-- 搜索框 -->
            <div class="serchAbuttom">
              <div class="mb-5">
                <a :class="selectType == 0
                  ? 'ml-10 mr-10 fs-14  activeItem'
                  : ' ml-10 mr-10 fs-14'
                  " @click="selectTypes(0)">{{ $t("商品") }}</a>
                <a :class="selectType == 1 ? 'mr-10 fs-14  activeItem' : 'mr-10 fs-14'
                  " @click="selectTypes(1)">{{ $t("公司") }}</a>
              </div>
              <el-input v-model="searchData" style="width: 100%; height: 47px" size="large" :placeholder="selectType == 0 ? $t('请输入商品名称') : $t('请输入公司名称')
                " suffix-icon="el-icon-search" clearable />
            </div>
          </el-col>

          <el-col :lg="8" :md="8" class="d-none d-lg-block">
            <!-- <div class="hm-minicart_area">
              <div class="item">
                <router-link to="/cart">
                  <i class="iconfont icon-gouwuche"></i>
                  <div class="badge">{{ cardCount }}</div>
                </router-link>
              </div>
              <div class="item">
                <el-popover placement="bottom"  trigger="click" >
                  <router-link v-for="item in menuList" :key="item.name" :to="item.path">
                    <div class="menu-item">{{ item.name }}</div>
                  </router-link>
                  <i slot="reference" style="cursor: pointer;" class="iconfont icon-gerenzhongxin"></i>
                </el-popover>
              </div>
            </div> -->
            <div class="buttomList">
              <el-button type="primary" style="height: 42px" @click="gotoListPage">{{ $t("搜索") }}</el-button>
              <el-button type="success" style="height: 42px" @click="businees_publish">{{ $t("发布商机") }}</el-button>
              <el-button style="height: 42px">
                <LayoutCart ref="head"></LayoutCart>
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 菜单信息 -->
    <div v-if="!isCartRoute" :class="{
      'header-bottom_area': true,
      'bg--tangerine_yellow': yellowType,
    }">
      <div class="container">
        <el-row :gutter="1" type="flex" align="middle" class="" style="width: 1200px">
          <el-col :md="6" :sm="18" :xs="14">
            <!-- 菜单 -->
            <div class="category-menu">
              <div @click="toggleShowChildNav" class="category-heading">
                <h2 class="categories-toggle flex-row">
                  <!-- <i class="iconfont icon-zhedie2"></i> -->
                  <i class="el-icon-s-unfold mr-7 fs-25"></i>
                  <span>{{ $t("产品品类") }}</span>
                </h2>
              </div>
              <!-- 主要内容 -->
              <!-- <div v-show="false && showChildNav" class="category-menu-list"> -->
              <div v-show="Isindex" class="category-menu-list">
                <ul :class="{ open: openCategoryList }">
                  <!-- <router-link to="/shop"> -->
                  <li class="liItem" v-for="(item, index) in product_List" :key="index" :title="item.name">
                    {{ lang == "zh" ? item.note : item.keyS }}
                    <div class="layer">
                      <ul>
                        <li v-for="i in item.sysDictList" :key="i.id" @click="click_item_li(i, item)">
                          <RouterLink :to="`/`">
                            <div class="flex-col item">
                              <div style="
                                  width: 100%;
                                  height: 80%;
                                  padding: 0;
                                  margin: 0;
                                  color: black;
                                " class="">
                                <img :src="i.remark ? i.remark : ''" alt="" />
                                <!-- <img src="../../assets/images/product/product01-3.png" alt="" /> -->
                              </div>
                              <div style="
                                  width: 100%;
                                  height: 20%;
                                  padding: 0;
                                  margin: 0;
                                " class="">
                                <div class="name ellipsis-2">
                                  {{ lang == "zh" ? i.note : i.keyS }}
                                </div>
                              </div>

                              <!-- <img :src="i.picture ? i.picture : ''" alt="" />
                                <div class="name ellipsis-2 bortest">{{ i.cname }}</div> http://yjy-xiaotuxian-dev.oss-cn-beijing.aliyuncs.com/picture/2021-04-15/e83efb1b-309c-46f7-98a3-f1fefa694338.jpg-->
                            </div>
                          </RouterLink>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <!-- </router-link> -->
                </ul>

                <div @click="toggleCategory" class="category-more">
                  <!-- <div v-show="openCategoryList">
                    pack up
                    <i class="el-icon-arrow-up"></i>
                  </div>
                  <div v-show="!openCategoryList">
                    more
                    <i class="el-icon-arrow-down"></i>
                  </div> -->
                </div>
              </div>
            </div>
          </el-col>
          <el-col :md="14" class="d-none d-lg-block">
            <nav class="main_nav">
              <ul>
                <!-- 菜单栏 -->
                <li :class="{ active: currentPageName === 'HOME' }">
                  <router-link class="menu-link" to="/home">{{
                    $t("首页")
                  }}</router-link>
                </li>
                <li :class="{ active: currentPageName === 'qpjnh' }">
                  <router-link class="menu-link" to="/qpjnh">{{
                    $t("汽配嘉年华")
                  }}</router-link>
                </li>
                <!-- <li :class="{'active': currentPageName === 'REGISTER'}">
                  <router-link to="/register">REGISTER</router-link>
                </li> -->
                <li :class="{ active: currentPageName === 'qpgtt' }">
                  <router-link class="menu-link" to="/qpgtt">{{
                    $t("汽配港头条")
                  }}</router-link>
                </li>
                <li :class="{ active: currentPageName === 'company' }">
                  <router-link class="menu-link" to="/company">{{
                    $t("企业库")
                  }}</router-link>
                </li>
                <li :class="{ active: currentPageName === 'SHOP' }">
                  <router-link class="menu-link" to="/shop">{{
                    $t("产品库")
                  }}</router-link>
                </li>
                <li :class="{ active: currentPageName === 'selection' }">
                  <span class="menu-link" @click="goSelection">{{ $t("选品中心") }}</span>
                </li>
                <li :class="{ active: currentPageName === 'business' }">
                  <router-link class="menu-link" to="/business">{{
                    $t("撮合商机")
                  }}</router-link>
                </li>
                <li :class="{ active: currentPageName === 'aboutUs' }">
                  <router-link class="menu-link" to="/aboutUs">{{
                    $t("关于我们")
                  }}</router-link>
                </li>
              </ul>
            </nav>
          </el-col>
          <!-- <el-col :sm="6" :xs="10" class="d-none d-lg-block">
            <div :class="{'contact-box': true,'dark': !yellowType}">
              <a href="https://www.facebook.com/p/BBmart-Auto-Parts-100082812802804/" target="_blank">
                <i class="iconfont icon-mianshulogo"></i>
              </a>
              <a href="https://www.instagram.com/bbmartautoparts/" target="_blank">
                <i class="iconfont icon-instagram-fill big"></i>
              </a>
              <a href="mailto:ann.wu@apware.cn" title="ann.wu@apware.cn">
                <i slot="reference" class="iconfont icon-youjian1 big"></i>
              </a>
              <a href="https://wa.me/8618611410380" title="whatsapp：+8619926065615">
                <i slot="reference" class="iconfont icon-whatsapp small"></i>
              </a>
              <a href="https://www.youtube.com/@bbmartautoparts5963/featured" target="_blank">
                <i class="iconfont icon-Youtube-fill big"></i>
              </a>
            </div>
          </el-col>
          <el-col :sm="6" :xs="10" class="d-block d-lg-none">
            <div class="mobile-menu_area">
              <ul>
                <li class="minicart-area">
                  <router-link to="/cart">
                    <i class="iconfont icon-gouwuche"></i>
                    <div class="item-count">{{ cardCount }}</div>
                  </router-link>
                </li>
                <li @click="toggleSideNav">
                  <i class="iconfont icon-31liebiao"></i>
                </li>
              </ul>
            </div>
          </el-col> -->
        </el-row>
      </div>
    </div>

    <!-- 下拉菜单 -->
    <div :class="{ 'mobile-menu_wrapper': true, open: showSideNav }">
      <div class="offcanvas-menu-inner">
        <div class="container">
          <div @click="toggleSideNav" class="btn-close">
            <i class="el-icon-close"></i>
          </div>
          <div class="offcanvas-inner_search">
            <div class="hm-searchbox">
              <input type="text" placeholder="Search product..." />
              <button class="search_btn">
                <i class="el-icon-search"></i>
              </button>
            </div>
          </div>
          <nav class="offcanvas-navigation">
            <ul class="mobile-menu">
              <li v-for="item in mobileMenuList" :key="item.name">
                <router-link :to="item.path">{{ item.name }}</router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <!-- 滚动后的菜单 -->
    <div v-show="showFixNav" class="header-bottom_area header-sticky">
      <div class="container">
        <el-row :gutter="30" type="flex" align="middle">
          <el-col :md="6" :sm="18" :xs="14">
            <div class="header-logo">
              <router-link to="/home">
                <!-- <img src="../../assets/images/BBmart logo.png" alt=""> -->
                <!-- <div class="shouyeImg flex-row">
                  <img src="../../assets/images/deflault_load.png" style="width: 48%; height: 90%;" class="" />

                  <div class="flex-row text_font fs-25 flex-col mt-7 ml-10" style="width: 100px">
                    <div class="">{{ $t("广园汇") }}</div>
                    <div class=" " style="white-space: nowrap">
                      {{ $t("汽配港") }}
                    </div>
                  </div>
                </div> -->
                <div style="width: 100%;margin-top: -20px;">
                  <img src="../../assets/images/deflault_logo.png" class="" style="width: 200px;" />
                </div>
              </router-link>
            </div>
          </el-col>
          <el-col :md="14" class="d-none d-lg-block">
            <nav class="main_nav">
              <ul>
                <!-- 菜单栏 -->
                <li :class="{ active: currentPageName === 'HOME' }">
                  <router-link class="menu-link" to="/home">{{
                    $t("首页")
                  }}</router-link>
                </li>
                <li :class="{ active: currentPageName === 'qpjnh' }">
                  <router-link class="menu-link" to="/qpjnh">{{
                    $t("汽配嘉年华")
                  }}</router-link>
                </li>
                <!-- <li :class="{'active': currentPageName === 'REGISTER'}">
                  <router-link to="/register">REGISTER</router-link>
                </li> -->
                <li :class="{ active: currentPageName === 'qpgtt' }">
                  <router-link class="menu-link" to="/qpgtt">{{
                    $t("汽配港头条")
                  }}</router-link>
                </li>
                <li :class="{ active: currentPageName === 'company' }">
                  <router-link class="menu-link" to="/company">{{
                    $t("企业库")
                  }}</router-link>
                </li>
                <li :class="{ active: currentPageName === 'SHOP' }">
                  <router-link class="menu-link" to="/shop">{{
                    $t("产品库")
                  }}</router-link>
                </li>
                <li :class="{ active: currentPageName === 'selection' }">
                  <span class="menu-link" @click="goSelection">{{ $t("选品中心") }}</span>
                </li>
                <li :class="{ active: currentPageName === 'business' }">
                  <router-link class="menu-link" to="/business">{{
                    $t("撮合商机")
                  }}</router-link>
                </li>
                <li :class="{ active: currentPageName === 'aboutUs' }">
                  <router-link class="menu-link" to="/aboutUs">{{
                    $t("关于我们")
                  }}</router-link>
                </li>
              </ul>
            </nav>
          </el-col>

          <el-col :sm="6" :xs="10" class="d-none d-lg-block">
            <div class="hm-minicart_area">
              <!-- <div class="item">
                <i class="iconfont icon-shoucang"></i>
                <div class="badge">20</div>
              </div> -->
              <div class="item mb-18">
                <router-link to="/cart">
                  <i class="iconfont icon-gouwuche"></i>
                  <!-- <div class="badge">{{ cardCount }}</div> -->
                </router-link>
              </div>
              <div class="item">
                <el-popover placement="bottom" trigger="click">
                  <router-link v-for="item in menuList" :key="item.name" :to="item.path">
                    <div class="menu-item">{{ item.name }}</div>
                  </router-link>
                  <i slot="reference" style="cursor: pointer" class="iconfont icon-gerenzhongxin"></i>
                </el-popover>
              </div>
            </div>
          </el-col>

          <el-col :sm="6" :xs="10" class="d-block d-lg-none">
            <div class="mobile-menu_area">
              <ul>
                <li class="minicart-area">
                  <router-link to="/cart">
                    <i class="iconfont icon-gouwuche"></i>
                    <div class="item-count">{{ cardCount }}</div>
                  </router-link>
                </li>
                <li @click="toggleSideNav">
                  <i class="iconfont icon-31liebiao"></i>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 回到顶部 -->
      <!-- <div @click="byScrollTop" class="back-box">
        <i class="el-icon-arrow-up"></i>
      </div> -->
    </div>

    <!-- 联系方式 -->
    <div class="contact-fixed d-block d-lg-none">
      <div class="contact-fixed-item">
        <a href="https://www.facebook.com/p/BBmart-Auto-Parts-100082812802804/" target="_blank">
          <i class="iconfont icon-mianshulogo"></i>
        </a>
      </div>
      <div class="contact-fixed-item">
        <a href="https://www.instagram.com/bbmartautoparts/" target="_blank">
          <i class="iconfont icon-instagram-fill"></i>
        </a>
      </div>
      <div class="contact-fixed-item">
        <a href="mailto:ann.wu@apware.cn" title="ann.wu@apware.cn">
          <i class="iconfont icon-youjian1"></i>
        </a>
        <!-- <el-popover placement="left" trigger="click" content="ann.wu@apware.cn">
          <i slot="reference" class="iconfont icon-youjian1"></i>
        </el-popover> -->
      </div>
      <div class="contact-fixed-item">
        <!-- <el-popover placement="left" trigger="click" content="whatsapp：+8619926065615">
          <i slot="reference" class="iconfont icon-whatsapp"></i>
        </el-popover> -->
        <a href="https://wa.me/8618611410380" title="whatsapp：+8619926065615">
          <i class="iconfont icon-whatsapp"></i>
        </a>
      </div>
      <div class="contact-fixed-item">
        <a href="https://www.youtube.com/@bbmartautoparts5963/featured" target="_blank">
          <i class="iconfont icon-Youtube-fill"></i>
        </a>
      </div>
    </div>

    <!-- 侧边栏 -->
    <div class="button-container">
      <button class="side-button" @click="comingsoon">
        <i class="el-icon-service fs-25"></i>
      </button>
      <button class="side-button" @click="comingsoon">
        <i class="el-icon-bell fs-25"></i>
      </button>
      <button class="side-button" @click="byScrollTop">
        <i class="el-icon-upload2 fs-25"></i>
      </button>
      <button class="side-button" style="white-space: nowrap; background-color: #16a753" @click="businees_publish">
        {{ $t("发布RFQ") }}
      </button>
    </div>
  </header>
</template>

<script>
import LayoutCart from "./LayoutCart";
import { getProducts, getheadList } from "../../apis/home";

export default {
  components: {
    LayoutCart,
  },
  props: {
    currentPageName: {
      type: String,
      default: "HOME",
    },
    yellowType: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      cartCount: 0,
      showChildNav: false,
      showSideNav: false,
      showFixNav: false,
      isDark: false,
      lang: "",
      departementNavList: [
        {
          name: "AIP FILTER",
          category: "Air Filters",
          children: [],
        },
        {
          name: "OIL FILTER",
          category: "Oil Filters",
          children: [],
        },
        {
          name: "IGNTION COIL",
          category: "Ignition Coils",
          children: [],
        },
        {
          name: "FUEL PUMP",
          children: [],
        },
        {
          name: "BRAKE PAD",
          children: [],
        },
        {
          name: "ABS SENSOR",
          children: [],
        },
        {
          name: "DRIVE SHAFT",
          children: [],
        },
        {
          name: "FOR PORSCHE",
          children: [],
        },
        {
          name: "C.V.JOINT",
          children: [],
        },
        {
          name: "WINDSHIELE WASHER PUMP",
          children: [],
        },
        {
          name: "STEERING RACK",
          children: [],
        },
        {
          name: "CLUTCH DISC",
          children: [],
        },
        {
          name: "SHOCK ABSORBER",
          children: [],
        },
        {
          name: "CONTORL ARM",
          children: [],
        },
        {
          name: "BALL JOINT",
          children: [],
        },
        {
          name: "STABILIZER LINK",
          children: [],
        },
        {
          name: "TIE ROD END",
          children: [],
        },
        {
          name: "RACKEND",
          children: [],
        },
        {
          name: "STRUT MOUNT",
          children: [],
        },
        {
          name: "ENGINE MOUNTING",
          children: [],
        },
        {
          name: "SUSPENSION BUSHING",
          children: [],
        },
        {
          name: "TAILGATE GAS STRUT",
          children: [],
        },
        {
          name: "WHEEL HUB BEARING",
          children: [],
        },
        {
          name: "RELEASE BEARING",
          children: [],
        },
        {
          name: "BEARING",
          children: [],
        },
        {
          name: "ALTERNATOR",
          children: [],
        },
        {
          name: "BRAKE DISC",
          children: [],
        },
        {
          name: "IGNTION CABLES",
          children: [],
        },
        {
          name: "BUMPER",
          children: [],
        },
        {
          name: "UNIVERSAL",
          children: [],
        },
        {
          name: "PROPSHAFT JOINT",
          children: [],
        },
        {
          name: "FUEL FILTER",
          children: [],
        },
        {
          name: "HEAER CORE",
          children: [],
        },
        {
          name: "HEAT EXCHANGER",
          children: [],
        },
        {
          name: "SHOCK BELLOW",
          children: [],
        },
        {
          name: "WHEEL CYLINDER",
          children: [],
        },
        {
          name: "WATER PUMP",
          children: [],
        },
      ],
      openCategoryList: false,
      showBackTop: false,
      menuList: [
        {
          name: "Sign in",
          path: "/login",
        },
        {
          name: "Register",
          path: "/register",
        },
        {
          name: "Order",
          path: "/order",
        },
      ],
      mobileMenuList: [
        {
          name: "HOME",
          path: "/home",
        },
        {
          name: "PRODUCT LIST",
          path: "/shop",
        },
        {
          name: "SIGN IN",
          path: "/login",
        },
        {
          name: "REGISTER",
          path: "/register",
        },
        {
          name: "ORDER",
          path: "/order",
        },
      ],
      searchData: "",
      selectType: 0,
      product_List: [
        {
          name: "底盘系列",
          children: [
            {
              img: [
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
              ],
            },
          ],
        },
        {
          name: "汽车养护",
          children: [
            {
              img: [
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
              ],
            },
            {
              img: [
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
              ],
            },
            {
              img: [
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
              ],
            },
            {
              img: [
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
              ],
            },
            {
              img: [
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
              ],
            },
          ],
        },
        {
          name: "车身系列",
          children: [
            {
              img: [
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
              ],
            },
          ],
        },
        {
          name: "发动机系列",
          children: [
            {
              img: [
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
                "https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh127f048a90a6489682855981c55b9928中承.png",
              ],
            },
          ],
        },
      ],
      Isindex: false,
    };
  },
  computed: {
    cardCount() {
      return this.$store.state.cartCount;
    },
    isCartRoute() {
      return this.$route.path === "/cart";
    },
  },
  created() {
    this.lang = localStorage.getItem("language") == "zh" ? "zh" : "en";
    this.showChildNav = this.yellowType;
    this.byScrollTop();
    if (window.localStorage.getItem("cartIdArr")) {
      let arr = window.localStorage.getItem("cartIdArr").split(",");
      this.$store.commit("setCartCount", arr.length);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.showNav);
    window.addEventListener("resize", this.resizeWindow);
    this.resizeWindow();
    this.getDataList();
    this.Channel();
  },
  destroyed() {
    window.removeEventListener("scroll", this.showNav);
    window.removeEventListener("resize", this.resizeWindow);
  },
  methods: {
    // 跳转到选品中心
    goSelection() {
      const token = localStorage.getItem('token')
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const url = window.location.href
      const a = document.createElement('a')
      a.target = '_blank'
      if (token) {
        if (userInfo.isVIP == 0) {
          this.$router.push({
            path: "/selection"
          })
          return
        }
        if (url.indexOf('gyh-sit') > -1) {//测试环境
          a.href = `https://open-api.alibaba.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=https://gyhconsole-sit.apbenben.com/authorization&client_id=504334`
          // a.href = `https://gyhconsole-sit.apbenben.com/authorization?token=${token}`
        } else {
          a.href = `https://open-api.alibaba.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=https://admin.gyhauto.com/authorization&client_id=504334`
          // a.href = `https://admin.gyhauto.com/authorization?token=${token}`
        }
        a.click()
      } else {
        // 没有入驻的商家跳转至介绍页
        this.$router.push({
          path: "/selection"
        })
      }
    },
    /** 监听窗口变化 */
    resizeWindow() {
      if (this.yellowType) {
        if (window.innerWidth < 992) {
          this.showChildNav = false;
          this.openCategoryList = false;
        } else {
          this.showChildNav = true;
        }
      }
    },
    /** 回到顶部 */
    byScrollTop() {
      document.documentElement.scrollTop = 0;
      window.pageYOffset = 0; // 兼容ios
      document.body.scrollTop = 0; // 兼容低版本ie
    },
    toggleCategory() {
      this.openCategoryList = !this.openCategoryList;
    },
    /** 控制吸顶菜单显隐 */
    showNav() {
      let scrollTop =
        window.pageYOffset ||
        document.body.scrollTop ||
        document.documentElement.scrollTop;
      if (scrollTop > 174) {
        this.showFixNav = true;
      } else {
        this.showFixNav = false;
      }
      if (scrollTop > 400) {
        this.showBackTop = true;
      } else {
        this.showBackTop = false;
      }
    },
    /** 切换侧边菜单 */
    toggleSideNav() {
      this.showSideNav = !this.showSideNav;
    },
    /** 切换子菜单 */
    toggleShowChildNav() {
      this.Isindex = !this.Isindex;
      if (!this.Isindex) {
        this.Isindex = false;
      }
    },
    selectTypes(e) {
      this.selectType = e;
    },
    gotoListPage() {
      this.$router.replace({
        path: ["/shop", "/company"][this.selectType],
        query: {
          title: this.searchData,
        },
      });
    },
    // 数据获取
    async getDataList() {
      const headList = await getheadList();
      this.product_List = headList.data;

      // this.product_List = this.handleDataList(ProductsList.data)
    },
    // 产品数据分离
    handleDataList(data) {
      const result = Object.keys(data).map((key) => {
        const temp = {
          name: key,
          children: data[key].map((child) => {
            const temp = {
              ...child,
              img: child.picture.split(","),
            };
            return temp;
          }),
        };

        return temp;
      });
      return result;
    },
    // 路由更改
    Channel() {
      this.Isindex = this.$route.path === "/home";
    },
    // 路由跳转
    businees_publish() {
      this.$router.push({ name: "Businees_publish" });
      // console.log(123)
    },
    //惊奇期待
    comingsoon() {
      this.$message({
        message: this.$i18n.t("该功能尚未开通，敬请期待!"),
        center: true,
      });
    },
    // 二级分类跳转
    click_item_li(i, item) {
      this.$router.push({
        path: "/shop",
        query: { ...i, fkeyS: item.keyS, fnote: item.note },
      });
    },
    // test
    hahah() {
      console.log(112321312312323);
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: black;
}

.shouyeImg {
  // width: 200px;
  height: 100px;
  width: 100%;

  // border-radius: 50%;
  // background-image: url("../../assets/images/shouye.png");
  // background-size: 100% auto;
  // background-size: cover;
  /* 可选，用于调整背景图片大小 */
  // background-color: #00000000;
  // filter: url(#f1);
  .text_font {
    justify-items: center;
    align-items: center;
    color: #24a2ff;
    font-weight: bolder;
    height: 100px;
    margin-top: 10px;
    line-height: 31px;
  }
}

.buttomList {
  white-space: nowrap;
}

.hm-minicart_area {
  text-align: right;
  padding-right: 20px;

  a {
    color: unset;
  }

  .item {
    color: #000000;
    display: inline-block;
    position: relative;

    &:last-of-type {
      margin-left: 24px;
    }

    .iconfont {
      font-size: 21px;
    }

    .badge {
      width: 25px;
      line-height: 25px;
      height: 25px;
      color: #fff;
      text-align: center;
      font-size: 12px;
      border-radius: 50%;
      background: #d54029;
      position: absolute;
      right: -18px;
      top: -18px;
    }
  }
}

.header-middle_area {
  background: white;
  padding: 30px 0;

  .container {
    .header-logo {
      @media only screen and (max-width: 991px) {
        text-align: center;
      }

      img {
        width: 100%;
        // max-width: 154px;
        height: auto;
      }
    }

    .contact-info {
      display: flex;

      .contact-info_icon {
        width: 50px;
        line-height: 50px;
        text-align: center;

        .icon-dianhua {
          font-size: 40px;
          color: #fed100;
          vertical-align: middle;
        }
      }

      .contact-info_content {
        flex: 1;
        line-height: 24px;
        font-size: 15px;
        color: #7b7b7b;

        a {
          line-height: 24px;
          font-size: 15px;
          color: #7b7b7b;
        }
      }
    }

    .hm-form_area {
      width: 100%;
      height: 50px;
      position: relative;

      .input {
        border: 2px solid #fdb828;
        border-radius: 30px;
        font-size: 14px;
        height: 50px;
        width: 100%;
        padding: 0 60px 0 33px;
        outline-style: none;
      }

      .search_btn {
        border: 0;
        background: none;
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);

        .el-icon-search {
          font-size: 20px;
        }
      }
    }

    .serchAbuttom {
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-items: center;

      .activeItem {
        color: #4169e1;
      }
    }
  }
}

.header-bottom_area {
  &.header-sticky {
    transition: all 300ms ease-in 0s;
    z-index: 1003;
    padding: 20px 0;
    box-shadow: 0px 1px 5px 0px rgb(0 0 0 / 20%);
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    background: #fff;

    .header-logo {
      img {
        width: 154px;
      }
    }
  }

  .category-menu {
    position: relative;
    width: 241px;

    .category-heading {
      line-height: 1;
      background: #fed100;
      position: relative;
      cursor: pointer;
      padding: 10px 0;
      width: 100%;
      border-radius: 25px 25px 0 0;

      .categories-toggle {
        font-size: 20px;
        align-items: center;
        justify-content: center;

        span,
        i {
          display: inline-block;
          position: relative;
          top: 0px;
        }
      }
    }

    // 主要内容list
    .category-menu-list {
      margin-top: 4px;
      background: #ffffff;
      // border: 1px solid #000000;
      border-radius: 0 0 25px 25px;
      padding: 0 20px;
      position: absolute;
      left: 0;
      top: calc(100% - 1px);
      display: block;
      width: 100%;
      z-index: 1002;

      ul {
        min-height: 430px;
        overflow: hidden;

        &.open {
          height: auto;
          overflow: auto;
        }

        li {
          color: rgb(24, 77, 127);
          font-size: 15px;
          font-weight: 600;
          line-height: 50px;
          // border-bottom: 1px solid #ebebeb;
          padding: 8.4px 0;
          cursor: pointer;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;

          &:hover {
            color: rgb(50, 50, 50);
          }

          a {
            margin-right: 4px;
            color: #fff;

            &:first-child {
              font-size: 16px;
            }
          }

          .layer {
            width: 740px;
            min-height: 418px;
            background: white;
            position: absolute;
            left: 224px;
            top: 0;
            display: none;
            padding: 0 0px;
            border-radius: 10px;

            // display: block;
            ul {
              display: flex;
              flex-wrap: wrap;

              li {
                margin: 10px 10px;
                width: 130px;
                height: 156px;
                padding: 10px;
                background: #fff;
                display: block;

                .item {
                  width: 100%;
                  height: 100%;
                  text-align: center;

                  img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                  }
                }

                &:nth-child(3n) {
                  margin-right: 0;
                }

                a {
                  display: flex;
                  width: 100%;
                  height: 100%;
                  align-items: center;
                  padding: 10px;

                  &:hover {
                    // background: #e3f9f4;
                    border: 1px solid #24a2ff;
                  }

                  .name {
                    font-size: 13px;
                    color: #666;
                    word-wrap: break-word;
                    white-space: normal;
                  }

                  .desc {
                    color: #999;
                  }
                }
              }
            }
          }

          // 关键样式  hover状态下的layer盒子变成block
          &:hover {
            .layer {
              display: block;
            }
          }
        }

        .liItem {
          border-bottom: 1px solid #ebebeb;
          padding-left: 10px;
          font-size: 17px;
        }
      }

      .category-more {
        line-height: 24px;
        font-size: 15px;
        text-align: center;
        color: #999;
        padding: 8.4px 0;
        cursor: pointer;
      }
    }
  }

  .main_nav {
    white-space: nowrap;

    li:first-child {
      margin-left: 0;
    }

    li {
      display: inline-block;
      cursor: pointer;
      margin-left: 20px;

      &.active {
        font-weight: bold;
        border-bottom: 3px solid #24a2ff;

        .a_active {
          color: #24a2ff;
        }
      }
    }

    /* 鼠标悬停时的样式 */
    .menu-link {
      color: #184d7f;
    }

    .menu-link:hover {
      color: #16a753;
      /* 鼠标悬停时的颜色 */
    }
  }

  .contact-box {
    line-height: 36px;
    color: #fff;
    display: flex;
    justify-content: flex-end;

    .iconfont {
      font-size: 30px;
      margin-left: 5px;
      vertical-align: middle;

      &.big {
        font-size: 32px;
      }

      &.small {
        font-size: 28px;
      }

      &.icon-mianshulogo {
        color: #3c5a99;
      }

      &.icon-instagram-fill {
        color: #e4007f;
      }

      &.icon-whatsapp {
        color: #3ac34c;
      }

      &.icon-Youtube-fill {
        color: #d54029;
      }
    }

    &.dark {
      color: #fed100;
    }
  }

  .mobile-menu_area {
    text-align: right;

    li {
      display: inline-block;
      cursor: pointer;

      .iconfont {
        font-size: 20px;
        font-weight: bold;
      }
    }

    .minicart-area {
      background-color: #fed100;
      width: 50px;
      height: 50px;
      line-height: 50px;
      border-radius: 25%;
      text-align: center;
      position: relative;
      margin-right: 15px;

      .icon-gouwuche {
        font-weight: normal;
        color: #fff;
      }

      .item-count {
        background: #d54029;
        color: #ffffff;
        position: absolute;
        top: -15px;
        right: -5px;
        width: 25px;
        height: 25px;
        line-height: 23px;
        font-size: 14px;
      }
    }
  }

  &.bg--tangerine_yellow {
    border-bottom: 2px solid rgb(24, 77, 127);

    .category-menu {
      .category-heading {
        background-color: rgb(24, 77, 127);
        border-radius: 0;

        .categories-toggle {
          color: #fff;
        }
      }

      .category-menu-list {
        border-top: 0;
        border-radius: 0;
      }
    }

    .main_nav {
      li {
        &.active {
          color: #fff;
        }

        &:hover {
          color: #fff;
        }
      }
    }
  }
}

.mobile-menu_wrapper {
  &.open {
    .offcanvas-menu-inner {
      transition: all 0.3s ease-in;
      left: auto;
      right: 0;
      visibility: visible;
      padding: 105px 0 0;
    }
  }

  .offcanvas-menu-inner {
    position: fixed;
    top: 0;
    right: -285px;
    width: 285px;
    height: 100%;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px 0px 10px 0px rgb(0 0 0 / 50%);
    z-index: 1004;
    visibility: hidden;
    transition: all 0.3s ease-in;

    .container {
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    }

    .btn-close {
      position: absolute;
      top: 0;
      left: -60px;
      background: #333333;
      width: 60px;
      height: 60px;
      line-height: 63px;
      text-align: center;
      color: #ffffff;
      z-index: 10;
      font-size: 24px;
      cursor: pointer;

      i {
        transform: rotate(0);
        transition: all 0.3s ease-in;
      }

      &:hover {
        background-color: #fed100;

        i {
          transform: rotate(90deg);
          color: #fff;
          transition: all 0.3s ease-in;
        }
      }
    }

    .offcanvas-inner_search {
      position: absolute;
      z-index: 9;
      top: 0;
      left: 0;
      width: calc(100% - 0px);
      padding: 10px;
      background-color: #ebebeb;

      .hm-searchbox {
        position: relative;

        input {
          background-color: #ebebeb;
          border: 0;
          height: 40px;
          line-height: 40px;
          width: 100%;
          padding: 0 52px 0 15px;
          outline: none;
        }

        .search_btn {
          background: transparent;
          color: #333333;
          position: absolute;
          top: 5px;
          right: 20px;
          border: 0;
          font-size: 24px;
        }
      }
    }

    .mobile-menu {
      overflow-y: auto;
      min-height: 165px;
      margin-right: -25px;
      padding-right: 25px;

      li {
        border-bottom: 1px solid #ebebeb;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        display: block;
        padding: 10px 0;
        cursor: pointer;

        &:last-of-type {
          border-bottom: 0;
        }
      }
    }
  }
}

.back-box {
  width: 50px;
  height: 50px;
  line-height: 48px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  background: #333;
  border: 1px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  position: fixed;
  right: 15px;
  bottom: 50px;

  &:hover {
    background: #fed100;
  }
}

.contact-fixed {
  width: 50px;
  height: auto;
  position: fixed;
  right: 15px;
  bottom: 105px;
  z-index: 99;

  .contact-fixed-item {
    width: 50px;
    height: 50px;
    line-height: 48px;
    text-align: center;
    color: #7b7b7b;
    margin-bottom: 5px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #f4f4f4;
    box-sizing: border-box;

    .iconfont {
      font-size: 30px;
      vertical-align: middle;
    }
  }
}

.menu-item {
  width: auto;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: #fdb828;
  }
}

.floating-image {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /* 添加过渡效果 */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  /* 阴影效果 */
}

/* 鼠标悬停时的浮空效果 */
.floating-image:hover {
  transform: translateY(-10px);
  /* 向上移动10px */
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  /* 加强阴影 */
}

/* 设置按钮容器的位置和布局 */
.button-container {
  position: fixed;
  width: 53px;
  right: 20px;
  /* 右侧 20px */
  top: 50%;
  /* 垂直居中 */
  transform: translateY(-50%);
  /* 精确居中 */
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* 纵向排列 */
  gap: 10px;
  /* 按钮之间的间隔 */
}

/* 设置按钮样式 */
.side-button {
  background-color: #184d7f;
  /* 按钮背景色 */
  color: white;
  /* 按钮文字颜色 */
  border: none;
  /* 去掉默认边框 */
  padding: 12px 10px;
  /* 按钮内边距 */
  font-size: 16px;
  /* 文字大小 */
  border-radius: 5px;
  /* 圆角效果 */
  cursor: pointer;
  /* 鼠标悬停时显示手型 */
  transition: background-color 0.3s ease;
  /* 背景色过渡 */
}

/* 鼠标悬停时改变按钮颜色 */
.side-button:hover {
  background-color: #0056b3;
  /* 鼠标悬停时背景色 */
}

/* 按钮焦点样式 */
.side-button:focus {
  outline: none;
  /* 去掉焦点框 */
}
</style>